export enum userTypes {
    LOADING = "LOADING",
    SELECTED_VIDANGE = "SELECTED_VIDANGE",
    GET_VIDANGE_LIST = "GET_VIDANGE_LIST",
}
  
export default userTypes;